const WORDS = ["De pessoa comum a empresário", "Método", "Acompanhamento", "Propósito", "Sem perder aquilo que realmente importa", "Troquei a segurança pela possibilidade"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((w) => (
      <span key={w} className="flex items-center whitespace-nowrap px-6 font-display text-2xl font-black uppercase tracking-tight sm:text-4xl">
        {w}
        <svg viewBox="0 0 20 20" className="ml-12 h-5 w-5 text-navy" aria-hidden><path d="M2 12 10 4l8 8" fill="none" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div className="relative overflow-hidden bg-orange py-6 text-white" data-testid="editorial-marquee">
    <div className="marquee-track flex w-max">
      <Row /><Row />
    </div>
  </div>
);
